export default {"src":"/_next/static/media/manawb.560e2d42.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};